import PropTypes from 'prop-types';
import { Box, Checkbox as MuiCheckbox } from '@mui/material';

import { ButtonConfirmIcon } from 'assets/icons';

const styles = {
  checkbox: ({ palette }, isHeader) => ({
    padding: 0,
    backgroundColor: palette.common.white,
    color: palette.common.white,
    borderRadius: '5px',
    border: `2px solid ${isHeader ? palette.common.white : palette.colors.darkPale}`,
    '&.Mui-disabled': {
      color: palette.common.white,
      opacity: 0.5,
      cursor: 'not-allowed !important',
      pointerEvents: 'unset',
    },
    '&.Mui-checked': {
      backgroundColor: palette.colors.coralDefault,
      borderColor: isHeader ? palette.common.white : palette.colors.coralDefault,
    },
  }),
  icon: ({ palette }) => ({
    width: 24,
    height: 24,
    padding: 0.5,
    color: palette.common.white,
  }),
};

const Checkbox = ({
  checked,
  onChange = null,
  inputProps = {},
  innerRef = null,
  disabled = false,
  isHeader = false,
  label = '',
  ...props
}) => {
  const handleChange = (event, newValue) => {
    if (typeof onChange === 'function') {
      onChange(newValue);
    }
  };

  return (
    <MuiCheckbox
      {...props}
      ref={innerRef}
      disableRipple
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      label={label}
      color="primary"
      checkedIcon={<Box component={ButtonConfirmIcon} sx={styles.icon} />}
      inputProps={{ ...inputProps }}
      sx={(theme) => styles.checkbox(theme, isHeader)}
    />
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  inputProps: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func,
  isHeader: PropTypes.bool,
  innerRef: PropTypes.func,
  label: PropTypes.string,
};
export default Checkbox;
